var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")]),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.setHeadersBySetting,"items":_vm.warrantErr,"hide-default-footer":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }